module.exports = __webpack_public_path__ + "static/media/or.379798df.svg";